export default {
  items: [
    // {
    //   name: 'Dashboard',
    //   url: '/dashboard',
    //   icon: 'icon-speedometer',
    //   badge: {
    //     variant: 'primary',
    //     text: 'NEW'
    //   }
    // },
    {
      name: 'Agents',
      url: '/agents',
      icon: 'icon-people',
      children: [
        {
          name: 'View Agents',
          url: '/agents/list'
        },
        {
          name: 'Add Agent',
          url: '/agents/add'
        }
      ]
    },
    {
      name: 'Bookings',
      url: '/bookings',
      icon: 'icon-note',
      children: [
        {
          name: 'View Bookings',
          url: '/bookings/list'
        },
        {
          name: 'Add Bookings',
          url: '/bookings/add'
        },
        {
          name: 'Import Bookings',
          url: '/bookings/import'
        }
      ]
    },
    // {
    //   name: 'Service Vouchers',
    //   url: '/service-vouchers',
    //   icon: 'icon-direction',
    //   children: [
    //     {
    //       name: 'View Vouchers',
    //       url: '/service-vouchers/list',
    //       icon: 'icon-direction'
    //     }
    //   ]
    // },
    {
      name: 'Invoices',
      url: '/invoices',
      icon: 'fa fa-money',
      children: [
        {
          name: 'View Invoices',
          url: '/invoices/list'
        },
        {
          name: 'Add Invoices',
          url: '/invoices/add'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js